import { NavProvider } from "./contexts/navContext"
import { Body } from "./components/body"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { PrivateRouter } from "./components/privateRoute"
import Login from "./components/login"
import Dashboard from "./components/dashboard"
import { AuthProvider } from "./contexts/authContext"
import { ImageProvider } from "./contexts/imageContext"
import { FeaturedProvider } from "./contexts/featuredContext"
import { ProjectsProvider } from "./contexts/otherProjectContext"
import { AboutProvider } from "./contexts/aboutContext"
import AnimatedCursor from "react-animated-cursor"
import "./styles/btn.css"
import "./styles/keyFrames.css"
import { HomeHero } from "./components/homeHero"
import About from "./components/about"
import Portfolio from "./components/portfolio"
import ContactForm from "./components/contact"

function App() {
  return (
    <>
      {/* <AnimatedCursor
        innerSize={20}
        outerSize={20}
        color='42, 157, 143'
        outerAlpha={0.2}
        innerScale={0.7}
        outerScale={4}
      ></AnimatedCursor> */}
      <AuthProvider>
        <NavProvider>
          <ImageProvider>
            <FeaturedProvider>
              <ProjectsProvider>
                <AboutProvider>
                  <Router>
                    <Routes>
                      <Route element={<Body />}>
                        <Route element={<HomeHero />} path="/" />
                        <Route element={<About />} path="/about" />
                        <Route element={<Portfolio />} path="/portfolio" />
                        <Route element={<ContactForm />} path="/contact" />
                      </Route>
                      <Route element={<Login />} path="/admin" />
                      <Route element={<PrivateRouter />} path="/dashboard">
                        <Route element={<Dashboard />} path="/dashboard" />
                      </Route>
                    </Routes>
                  </Router>
                </AboutProvider>
              </ProjectsProvider>
            </FeaturedProvider>
          </ImageProvider>
        </NavProvider>
      </AuthProvider>
    </>
  )
}

export default App
